import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { withElementWrapper } from "../withElementWrapper";
import PropTypes from "prop-types";
import { STATIC_KEYWORDS } from "../../../../../constants";
import { getCategoryAndSubCategory, getTemplateName } from "../../../../../ga-utils";

import "./also-read.m.css";

const AlsoReadBase = ({ story = {}, element, opts = {}, render, ...restProps }) => {
  const content = element.text;
  if (!content) return null;

  const config = useSelector((state) => get(state, ["qt", "config"], {}));
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));

  const linkedStories = get(story, ["linked-stories"], {});
  const linkedStoryId = get(element, ["metadata", "linked-story-id"]);
  const linkedStorySlug = get(linkedStories, [linkedStoryId, "url"]);

  const storyUrl = linkedStorySlug && linkedStorySlug;

  const { ALSO_READ: displayTitle } = STATIC_KEYWORDS;

  const trackAlsoReadClick = () => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: "also_read_click",
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  return (
    <Link
      className="arrow-component arr--also-read-element"
      styleName="alsoread-default"
      data-test-id="also-read"
      href={storyUrl}
      aria-label="also-read"
      disableAjaxLinks={true}
      onMouseDown={trackAlsoReadClick}
      {...restProps}
    >
      <div styleName="content-wrapper">
        <span styleName="default-text">
          {displayTitle}:&nbsp;
          <h3 styleName="headline" dangerouslySetInnerHTML={{ __html: content }} />
        </span>
      </div>
    </Link>
  );
};

AlsoReadBase.propTypes = {
  /**  template can be default, textLeftAlign or imageRightAlign */
  story: PropTypes.shape({ "linked-stories": PropTypes.object }),
  element: PropTypes.shape({
    text: PropTypes.string,
    metadata: PropTypes.shape({
      linkedStoryId: PropTypes.shape({ url: PropTypes.string, "hero-image-s3-key": PropTypes.string }),
    }),
  }),
  opts: PropTypes.shape({ title: PropTypes.string }),
  render: PropTypes.func,
};

export const AlsoRead = withElementWrapper(AlsoReadBase);
